<template>
    <div class="text-center my-3">
        <h3 class="font-weight-bold">
            <v-icon>mdi-domain</v-icon>
            DANH SÁCH CÔNG TY
        </h3>
    </div>
    <v-container>
        <v-row class="d-flex justify-center mx-auto" style="width: auto">
            <v-col cols="12" md="2" class="d-flex align-center justify-center">
                <v-btn elevation="0" color="primary" @click="openDialogUpdateCongTy(null)">
                    <v-icon class="mr-2">mdi-plus-circle</v-icon>
                    Thêm mới
                </v-btn>
            </v-col>
        </v-row>
    </v-container>

    <v-table style="width: 1000px" class="mx-auto">
        <thead>
            <tr>
                <th> Mã công ty </th>
                <th> Tên công ty</th>
                <th> Mô tả </th>
                <th> Thao tác </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in dataCompany" :key="item.CompanyID">
                <td>{{ item.CompanyID }}</td>
                <td>{{ item.CompanyName }}</td>
                <td>{{ item.Description }}</td>
                <td>
                    <div style="display: flex; gap: 2px; align-items: center;">
                        <v-icon color="primary" @click="openDialogUpdateCongTy(item)">mdi-pencil</v-icon>
                        <v-icon color="red" @click="showDialogDeleteConfirm(item)">mdi-delete</v-icon>
                    </div>
                </td>
            </tr>
        </tbody>
    </v-table>

    <v-dialog width="500" scrollable v-model="showDialogUpdate">
        <v-card prepend-icon="mdi-pencil-plus-outline" :title="dialogUpdateTitle">
            <v-divider class="mb-3"></v-divider>

            <v-text-field class="mx-4 mb-1" v-model="objCompany.CompanyName" label="Tên" variant="outlined"
                :error="!!errorMessage" :error-messages="errorMessage"></v-text-field>
            <v-text-field class="mx-4" v-model="objCompany.Description" label="Mô tả" variant="outlined"></v-text-field>

            <v-divider></v-divider>
            <v-card-actions>
                <v-btn text="ĐÓNG" @click="showDialogUpdate = false"></v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" text="LƯU" variant="flat" @click="saveUpdateAction"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogDelete" max-width="500px">
        <v-card>
            <v-card-title class="headline">Xác nhận xoá</v-card-title>
            <v-divider class="mb-3"></v-divider>
            <v-card-text class="text-center">
                Bạn có chắc xoá dữ liệu không?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="gray" variant="flat" text @click="showDialogDelete = false">Huỷ</v-btn>
                <v-btn color="red" variant="flat" text @click="deleteAction"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from '../utils/axios'
export default {
    name: 'QuanLyCongTyComponent',
    data: () => ({
        dataCompany: [],
        showDialogUpdate: false,
        showDialogDelete: false,
        dialogUpdateTitle: "",
        objCompany: {
            CompanyID: 0,
            CompanyName: "",
            Description: "",
        },
        errorMessage: "",
        colorMessage: "blue"
    }),
    mounted() {
        this.getCompany();
    },
    methods: {
        getCompany() {
            axios.get('/Company_SelectAll')
                .then((response) => { this.dataCompany = [...response.data]; })
                .catch((error) => { console.log(error); });
        },

        openDialogUpdateCongTy(obj) {
            this.errorMessage = "";
            this.showDialogUpdate = true;
            if (obj == null) {
                this.dialogUpdateTitle = "Thêm mới Công ty";
                this.objCompany = { CompanyID: 0, CompanyName: "", Description: "" };
            } else {
                this.dialogUpdateTitle = "Chỉnh sửa thông tin Công ty";
                this.objCompany = { ...obj };
            }
        },

        saveUpdateAction() {
            if (!this.objCompany.CompanyName.trim()) {
                this.errorMessage = "Tên công ty không được để trống!";
                this.colorMessage = "red";
                return;
            }

            axios.post('/Company_Add', this.objCompany)
                .then(() => {
                    this.showDialogUpdate = false;
                    this.getCompany();
                    this.errorMessage = "Cập nhật thành công!";
                    this.colorMessage = "blue";
                })
                .catch((error) => {
                    this.errorMessage = error.response?.data?.detail || "Có lỗi xảy ra!";
                    this.colorMessage = "red";
                });
        },

        showDialogDeleteConfirm(obj) {
            this.errorMessage = "";
            this.objCompany.CompanyID = obj.CompanyID;
            this.showDialogDelete = true;
        },

        deleteAction() {
            axios.post('/Company_Delete', { CompanyID: this.objCompany.CompanyID })
                .then(() => {
                    this.getCompany();
                    this.showDialogDelete = false;
                    this.errorMessage = "Xóa thành công!";
                    this.colorMessage = "blue";
                })
                .catch((error) => {
                    this.errorMessage = error.response?.data?.message || "Có lỗi xảy ra!";
                    this.colorMessage = "red";
                });
        },
    }
}
</script>
